angular.module('unergie.main')
.directive('timetables', ($rootScope, NgTableParams, ApiCons, DataAccess, BoFeaturesService, Rules, PaymentService, AuthService,
    DataAccessSearch, ContractService, ReferencesService, TimetableGeneration, MetaWatcher, ApiUser, AlertManager, ErrorCatcher, DataAccessReferences) => ({
    restrict: 'E',
    templateUrl: '/directives/timetables/timetables.html',
    link($scope) {
        $scope.currentContract = null
        const isEnvDev = BoFeaturesService.get('isEnvDev')
        const feats = BoFeaturesService.getModuleFeatures('contracts')
        const listProviderCalendar = DataAccessReferences.searchRefTable({
            idTable: 'urg_ref_provider_calendar',
            id: [
                'BASE',
                'HPHC',
            ],
        })

        $scope.canSeeInvoices = BoFeaturesService.isFeatureOn('canSeeInvoicesPage')
        $scope.canRegenEstimated = AuthService.userHasGroup('data-admin')
        $scope.canRegenTimetable = feats.canRegenTimetable

        $scope.regenEstimatedLabel = 'Générer !'
        $scope.regenTimetableLabel = null

        $scope.regenEstimatedData = false
        $scope.regenTimetableData = false

        $scope.regenEstimatedTemplate = null
        $scope.regenTimetableTemplate = {
            expl: {
                label: 'N/A',
                type: 'label',
            },
        }

        const generatorMapping = {
            noEstimated: {
                alert: true,
                algoShortName: "Pas d'estimé",
                algoLongName: "Il n'y a pas d'estimated au niveau du contrat",
            },
            errorToRetrieveEstimated: {
                alert: true,
                algoShortName: 'Erreur',
                algoLongName: "Impossible de récupérer l'estimé de ce contrat auprès d'ApiCons",
            },
            noAlgoId: {
                alert: true,
                algoShortName: 'Algo NA',
                algoLongName: "L'algorithme utilisé n'est pas renseigné dans ApiCons",
            },
            unknownAlgoId: {
                alert: true,
                algoShortName: 'Algo inconnu',
                algoLongName: "L'algorithme utilisé est renseigné mais inconnu du BO",
            },

            estimateWithMeasure: {
                algoShortName: 'Histo Enedis',
                algoLongName: "Estimé basé sur l'historique de consommation Enedis",
                version: {
                    1: ', confronté à des gradients calculés en 2016',
                    2: ', confronté à des gradients revus en février 2019',
                },
            },
            estimateWithEstimated: {
                algoShortName: 'Histo DIY',
                algoLongName: 'Estimé basé sur un historique de consommation hors-Enedis',
                needConsEstimated: true,
                version: {
                    1: ', confronté à des gradients calculés en 2016',
                    2: ', confronté à des gradients revus en février 2019',
                },
            },
            estimateWithConciliated: {
                algoShortName: 'Super moit-moit',
                algoLongName: "Estimé basé sur la moyenne entre l'histo conso Enedis et la conso déclarée",
                needConsEstimated: true,
                version: {
                    1: ', confronté à des gradients revus en février 2019',
                },
            },
            estimateWithLandscape: {
                algoShortName: 'Paysage',
                algoLongName: 'Estimé basé sur le paysage énergétique',
                version: {
                    1: ', sans prise en compte des températures de confort',
                    2: ', avec prise en compte des températures de confort',
                    3: ', avec prise en compte des températures de confort et amélioration des consommations moyennes des équipements',
                },
            },
        }


        $scope.newPaymentPayload = PaymentService.newPaymentPayload()

        $scope.newPaymentFields = PaymentService.newPaymentFields()

        $scope.generatePayment = () => PaymentService.generatePayment($scope.currentContract, $scope.newPaymentPayload)

        // SEND PAYMENT LINK
        $scope.sendingAnonLink = false
        $scope.paymentMailPayload = PaymentService.paymentMailPayload()

        $scope.paymentMailFields = PaymentService.paymentMailFields()

        const flatten = function (elem) {
            const single = !!elem[0].cons_details
            const hphc = (elem.length > 1) || (single && elem[0].cons_details.HP && elem[0].cons_details.HC)
            return {
                id: elem[0].id,
                date: elem[0].date,
                month: elem[0].month,
                year: elem[0].year,
                payment: elem[0].payment,
                id_p_calendar: hphc ? 'HP/HC' : 'BASE',
                status: !hphc || single || (hphc && (elem[0].status === elem[1].status)) ? elem[0].status : 95,
                amount: (hphc && !single && (elem.length > 1)) ? (elem[0].amountWithModif + elem[1].amountWithModif)
                    : elem[0].amountWithModif,
                details: elem,
                invoiced_in_v2: elem[0].invoiced_in_v2,
            }
        }

        const prepareRegenEstimated = function (contract, timetables) {
            if (!$scope.canRegenEstimated) {
                return
            }
            if (!contract || contract.status === 80 || contract.estimated_v !== 2 || !timetables || timetables.length <= 0 || !$scope.metadataEstimated || $scope.metadataEstimated.alert) {
                return ($scope.regenEstimatedData = false)
            }

            const idxLastTimetableNotRegenable = _.findLastIndex(timetables, (tt) => (tt.status !== 0 && tt.status !== 71))
            return listProviderCalendar.$promise.then((list) => {
                const firstTimetableRegenable = timetables[idxLastTimetableNotRegenable + 1]
                const mFirstTimetableRegenable = (firstTimetableRegenable)
                    ? moment(firstTimetableRegenable.date, 'YYYY-MM-DD')
                    : moment(timetables[idxLastTimetableNotRegenable].date, 'YYYY-MM-DD').startOf('month').add(1, 'month')
                const sFirstTimetableRegenable = mFirstTimetableRegenable.format('YYYY-MM-DD')
                const mode = (firstTimetableRegenable === timetables[0]) ? 'firstV2' : 'nextV2'
                $scope.regenEstimatedData = {
                    startDate: sFirstTimetableRegenable,
                    generator: $scope.metadataEstimated.generator.name,
                    calendar: contract.id_p_calendar,
                    mode,
                }

                const listGenerator = $scope.metadataEstimated.needConsEstimated
                    ? ['estimateWithMeasure', 'estimateWithConciliated', 'estimateWithEstimated']
                    : ['estimateWithMeasure']
                $scope.regenEstimatedTemplate = {
                    expl: {
                        type: 'label',
                        label: [
                            "Vous allez recalculer l'estimé<br>",
                            (mode === 'firstV2') ? "à partir de l'activation" : `à partir du ${mFirstTimetableRegenable.format('DD/MM/YYYY')}`,
                        ].join(''),
                    },
                    generator: {
                        type: 'select',
                        label: 'Algo',
                        required: true,
                        enum: listGenerator.map((gn) => {
                            return {
                                value: gn,
                                label: generatorMapping[gn].algoShortName,
                            }
                        }),
                    },
                    initiator: {
                        type: 'select',
                        label: 'Raison',
                        required: true,
                        enum: [
                            {
                                value: 'contractual amendment: update calendar',
                                label: 'update calendar',
                            },
                            {
                                value: 'contractual amendment: update calendar & power',
                                label: 'update calendar & power',
                            },
                            {
                                value: 'landscape updated',
                                label: 'landscape updated',
                            },
                            {
                                value: 'customer complaint',
                                label: 'customer complaint',
                            },
                            {
                                value: 'fill missing timetable',
                                label: 'fill missing timetable',
                            },
                            {
                                value: 'review declared cons',
                                label: 'review declared cons',
                            },
                        ],
                    },
                    calendar: {
                        type: 'select',
                        label: `Calendrier de la CAR&nbsp;<span class="fa fa-question-circle"` +
                        ` title="Vous pouvez saisir la CAR dans le calendrier de votre choix, dans tous les cas l'échéancier sera en '${contract.id_p_calendar}'" />`,
                        required: true,
                        enum: list.map((e) => ({ value: e.id, label: e.id })),
                        hidden: (regenData) => !generatorMapping[regenData.generator].needConsEstimated,
                    },
                }
                list.forEach((cal) => {
                    Object.keys(cal.dial).forEach((tempClass) => {
                        $scope.regenEstimatedTemplate[`cons_${cal.id}_${tempClass}`] = {
                            label: tempClass,
                            type: 'number',
                            required: true,
                            calendar: cal.id,
                            hidden: (regenData) => (!generatorMapping[regenData.generator].needConsEstimated || regenData.calendar !== cal.id),
                        }
                    })
                })
            })
        }

        const prepareRegenTimetable = function (contract, timetables) {
            if (!$scope.canRegenTimetable) {
                return
            }
            if (!contract) {
                return ($scope.regenTimetableData = false)
            }
            if (contract.estimated_v == null) {
                $scope.regenTimetableLabel = 'Générer !'
                $scope.regenTimetableTemplate.expl.label = "Vous allez générer l'estimé et<br>l'échéancier du contrat<br>à partir de sa date d'activation"
                if (contract.status === 80) {
                    $scope.regenTimetableTemplate.expl.label += '<br><br>et passer le contrat au statut Initial'
                }

                const mode = (contract.estimated_v === 0) ? 'firstV1' : 'firstV2'
                return ($scope.regenTimetableData = { mode })
            }
            if (!timetables || (timetables.length <= 0) || contract.status === 80) {
                $scope.regenTimetableLabel = 'Générer !'
                $scope.regenTimetableTemplate.expl.label = "Vous allez générer l'échéancier<br>du contrat à partir de sa date<br>d'activation, sans modifier<br>l'estimé"
                if (contract.status === 80) {
                    $scope.regenTimetableTemplate.expl.label += '<br><br>et passer le contrat au statut Initial'
                }

                const mode = (contract.estimated_v === 0) ? 'regenV1' : 'regenFirstV2'
                return ($scope.regenTimetableData = { mode })
            }

            const firstTimetable = timetables[0]
            const lastTimetable = timetables[timetables.length - 1]
            const mFirstTimetable = moment(`${firstTimetable.year}-${firstTimetable.month}-${firstTimetable.start_day || 1}`, 'YYYY-MM-DD')
            const firstMonthRegenable = timetables.reduce((acc, tt, i) => {
                if (acc) {
                    return acc
                }

                const ttShouldBe = moment(mFirstTimetable).startOf('month').add(i, 'month')
                if (tt.year !== ttShouldBe.year() || tt.month !== (1 + ttShouldBe.month())) {
                    return ttShouldBe.format('YYYY-MM')
                }

                if (tt.status === 0) {
                    return (i === 0) ? mFirstTimetable.format('YYYY-MM-DD') : ttShouldBe.format('YYYY-MM')
                }

                return acc
            }, null) || moment(`${lastTimetable.year}-${lastTimetable.month}-01`, 'YYYY-MM-DD').add(1, 'month').format('YYYY-MM')

            const mFirstMonthRegenable = moment(firstMonthRegenable, 'YYYY-MM-DD').startOf('month')
            const mLastMonthRegenable = moment($scope.metadataEstimated.endDate, 'YYYY-MM-DD')
            const nbMonthGap = Math.ceil(mLastMonthRegenable.diff(mFirstMonthRegenable, 'month', true))
            const listMonth = _.range(0, nbMonthGap).map((i) => {
                return (i === 0) ? firstMonthRegenable : moment(mFirstMonthRegenable).add(i, 'month').format('YYYY-MM')
            })

            $scope.regenTimetableLabel = 'Regénérer !'
            $scope.regenTimetableTemplate.expl.label = "Vous allez regénérer l'échéancier<br>(uniquement les mois sélectionnés)<br>sans modifier l'estimé<br><br>"
            if (contract.status === 80) {
                $scope.regenTimetableTemplate.expl.label += 'et passer le contrat au statut Initial<br><br>'
            }
            $scope.regenTimetableTemplate.startDate = {
                label: 'Date de début',
                type: 'select',
                required: true,
                enum: listMonth.map((e) => ({ value: e, label: e })),
            }
            $scope.regenTimetableTemplate.endDate = {
                label: "Date de fin (jusqu'à fin du mois)",
                type: 'select',
                required: true,
                enum: listMonth.map((e) => {
                    const d = e.split('-')
                    const sD = `${d[0]}-${d[1]}`
                    return { value: sD, label: sD }
                }),
            }

            const sStartDateSuggested = (firstMonthRegenable >= $scope.metadataEstimated.endDate) ? '' : firstMonthRegenable
            return ($scope.regenTimetableData = { mode: 'regenV2', startDate: sStartDateSuggested, endDate: '' })
        }

        const prepareRegen = function (contract, timetables) {
            prepareRegenEstimated(contract, timetables)
            prepareRegenTimetable(contract, timetables)
        }

        const loadTimetables = function (contract) {
            $scope.currentContract = contract
            if (contract) {
                return DataAccess.contractTimetablesWithModif({
                    id_contract: contract.id,
                    all: true,
                    cancelled: true,
                })
                .$promise.then((timetables) => {
                    const timetablesGrouped = _.groupBy(timetables, 'date')
                    const timetablesFlatten = _.map(timetablesGrouped, flatten)
                    $scope.tableParams = new NgTableParams({
                        count: 12,
                        sorting: { year: 'asc', month: 'asc' },
                    }, {
                        counts: [12, 25, 50, 100],
                        dataset: timetablesFlatten,
                    })

                    // TODO remove someday
                    if (contract.energy_type === 'GAS') {
                        return
                    }

                    if (contract.estimated_v == null) {
                        $scope.metadataEstimated = generatorMapping.noEstimated
                        return prepareRegen(contract, timetables)
                    }

                    return ApiCons.metadataV2({ idContract: contract.id }).$promise.then((metadata) => {
                        let algo = generatorMapping.noAlgoId
                        const idAlgo = metadata && metadata.generator && (metadata.generator.name || metadata.generator)
                        if (idAlgo) {
                            algo = generatorMapping[idAlgo]
                            if (!algo) {
                                algo = generatorMapping.unknownAlgoId
                            }
                            algo.id = idAlgo
                        }
                        if (algo.version) {
                            algo = Object.assign({}, algo)
                            const { version } = metadata.generator
                            algo.id += (` v${version}`)
                            algo.algoShortName += (` v${version}`)
                            const longName = algo.version[version]
                            if (longName) {
                                algo.algoLongName += longName
                            }
                        }
                        $scope.metadataEstimated = Object.assign(metadata, algo)
                        if (contract.estimated_v === 2) {
                            Object.assign($scope.metadataEstimated, $scope.metadataEstimated.coverage)
                            $scope.metadataEstimated.v = 2
                        }
                        return prepareRegen(contract, timetables)
                    })
                    .catch((err) => {
                        $scope.metadataEstimated = generatorMapping.errorToRetrieveEstimated
                        prepareRegen()
                        return ErrorCatcher(err)
                    })
                })
                .catch((err) => {
                    $scope.tableParams = null
                    prepareRegen()
                    return ErrorCatcher(err)
                })
            }

            $scope.tableParams = null
            return prepareRegen()
        }

        $scope.regenerateEstimated = function () {
            const now = (isEnvDev) ? moment('2017-01-01') : moment()
            const mode = $scope.regenEstimatedData.mode
            const calendar = $scope.regenEstimatedData.calendar
            const generator = generatorMapping[$scope.regenEstimatedData.generator]
            const query = {
                idContract: $scope.currentContract.id,
            }

            const body = {
                initiator: `mco: ${$scope.regenEstimatedData.initiator}`,
                timePeriod: (mode === 'firstV2') ? undefined : {
                    startDate: $scope.regenEstimatedData.startDate,
                },
                input: {
                    consEstimated: (!generator.needConsEstimated) ? undefined : {
                        calendar,
                        source: 'backoffice',
                        conciliate: ($scope.regenEstimatedData.generator === 'estimateWithConciliated'),
                        timePeriod: {
                            startDate: moment(now).subtract(1, 'year').format('YYYY-MM-DD'),
                            endDate: now.format('YYYY-MM-DD'),
                        },
                        cons: Object.keys($scope.regenEstimatedData).reduce((acc, key) => {
                            if (!key.startsWith(`cons_${calendar}_`)) {
                                return acc
                            }

                            const tempClass = key.split('_')[2]
                            acc[tempClass] = $scope.regenEstimatedData[key]
                            return acc
                        }, {}),
                        force: true,
                    },
                },
            }

            return TimetableGeneration[mode](query, body).$promise.then(() => {
                AlertManager.success('Génération OK')

                return loadTimetables($scope.currentContract)
            })
            .catch(ErrorCatcher)
        }

        $scope.regenerateTimetable = function () {
            const startDate = ($scope.regenTimetableData.startDate) ? moment($scope.regenTimetableData.startDate, 'YYYY-MM-DD').format('YYYY-MM-DD') : undefined
            const endDate = ($scope.regenTimetableData.endDate) ? moment($scope.regenTimetableData.endDate, 'YYYY-MM-DD').add(1, 'month').startOf('month').format('YYYY-MM-DD') : undefined
            const timePeriod = {
                startDate,
                endDate,
            }

            const query = {
                idContract: $scope.currentContract.id,
                precisely: true,
            }
            if ($scope.regenTimetableData.mode === 'regenV2') {
                query.reportMissCons = false
                query.simulateFullBillingPeriod = true
            }
            if ($scope.regenTimetableData.mode === 'firstV2' || $scope.regenTimetableData.mode === 'regenFirstV2') {
                delete query.precisely
            }

            const body = ($scope.regenTimetableData.mode === 'regenV2') ? { timePeriod } : timePeriod
            if ($scope.regenTimetableData.mode === 'firstV2') {
                body.initiator = ($scope.currentContract.status === 80) ? 'contract signed' : 'manual creation'
            }

            return TimetableGeneration[$scope.regenTimetableData.mode](query, body).$promise.then(() => {
                if ($scope.currentContract.status === 80) {
                    return DataAccess.changeContractStatus({ id_contract: $scope.currentContract.id, status: 0 }, {}).$promise
                }
            })
            .then(() => {
                AlertManager.success('Génération OK')

                return DataAccess.contract({ id: $scope.currentContract.id }).$promise.then((refreshContract) => {
                    if ($scope.currentContract.status === 80) {
                        return MetaWatcher.notif('CONTRACT_CHANGED', $scope.currentContract)
                    }
                    return loadTimetables($scope.currentContract)
                })
            })
            .catch(ErrorCatcher)
        }

        $scope.paymentIsAdvanceCons = (payment) => payment && (payment.status === 98)

        $scope.paymentNotOk = (payment) => payment && ((payment.status >= 90) && (payment.status < 98))

        $scope.timetablePaymentNotYetValidated = (payment) => payment && !$scope.paymentNotOk(payment) && PaymentService.paymentNotYetValidated(payment)

        $scope.timetablePaymentValidated = (payment) => payment && !$scope.paymentNotOk(payment) && !PaymentService.paymentNotYetValidated(payment)

        const loadAll = function (contract) {
            $scope.currentContract = contract
            return loadTimetables(contract)
        }


        ContractService.watch('timetables', loadAll)

        $scope.isNotEmpty = (obj) => obj && (Object.keys(obj).length !== 0)

        $scope.generationFields = {
            payment_date: {
                label: 'Date de paiement (optionnelle)',
                type: 'date',
            },
        }

        $scope.generating = {}

        $scope.generateTtForContract = function (tt) {
            $scope.generating[tt.id] = true
            const payload = { year: tt.year, month: tt.month, id_contract: $scope.currentContract.id }
            if (tt.payment_date) {
                payload.payment_date = moment(tt.payment_date).format('YYYY-MM-DD')
            }
            return Rules.monthlyBilling(payload).$promise.then((result) => {
                AlertManager.success('Génération effectuée')
                return MetaWatcher.notif('PAYMENT_CHANGED', $scope.currentContract) }).catch(ErrorCatcher)
            .finally(() => ($scope.generating[tt.id] = false))
        }

        ReferencesService.getRef('ttStatuses').then((mapping) => ($scope.ttMapping = mapping))

        ReferencesService.getRef('paymentStatuses').then((mapping) => ($scope.paymentMapping = mapping))

        $scope.fetchInitialEstimator = () => {
            return ApiUser.getContractInitialEstimator({ id: $scope.currentContract.id }).$promise
            .then((draftResult) => {
                const draft = draftResult.toJSON()
                let html = ''
                if ($scope.currentContract.bulk_purchase) {
                    html += `<h4>Estimation lors de l'achat groupé (CAR) :</h4>`
                    switch (draft.preferred_estimator) {
                        case 'AVERAGED_CONS':
                            html += `<span>Le client a choisi le super moit-moit (moitié de la différence entre l'estimé Plüm et la CAR transmise).</span>`
                            break
                        case 'CONS_MEASURE':
                            html += `<span>Le client a choisi de faire confiance à Plüm pour l'éstimation de sa consommation.</span>`
                            break
                        case 'DECLARED_CONS':
                            html += `<span>Le client a décidé d'utiliser la consommation qu'il a déclarée.</span>`
                            break
                        default:
                            html += `<span>Le client n'a pas renseigné de consommation estimée (cas d'une création manuelle de contrat ou de basculement vers l'offre achat groupé)</span>`
                    }
                    if (draft.declared_cons && draft.declared_cons.cons) {
                        html += `<br><div>CAR déclarée par le client :</div>`
                        html += `<ul><li>${_.map(draft.declared_cons.cons, (value, tempClass) => `<strong>${tempClass}</strong> : ${value} kWh/an`).join('</li><li>')}</li></ul>`
                    }
                }
                if (draft.draftElec && draft.draftElec.estimated_amendment && draft.draftElec.estimated_amendment.rate) {
                    html += `<h4>Modification de l'estimation demandée par le client :</h4>`
                    html += `<span>Lors de la souscription, le client a  choisi de ${draft.draftElec.estimated_amendment.priceModifPercentage < 0 ? 'diminuer' : 'augmenter'} `
                        + `de ${draft.draftElec.estimated_amendment.priceModifPercentage}% son échéancier initial.</span>`
                    html += `<br><span>Soit un taux de ${Math.round((draft.draftElec.estimated_amendment.rate - 1) * 100)}% sur l'estimation de sa consommation.</span>`
                }
                if (html === '') {
                    html += `<h4>Le client a choisi de faire confiance à Plüm pour l'estimation de sa consommation</h4>`
                }
                return html
            })
            .catch(ErrorCatcher)
        }

        $scope.getDeclaredCons = (first) => {
            return ApiCons[first ? 'getFirstDeclaredCons' : 'getLastDeclaredCons']({ id_contract: $scope.currentContract.id }).$promise
            .then((firstDeclaredConsResult) => {
                const firstDeclaredCons = firstDeclaredConsResult && firstDeclaredConsResult.toJSON()
                let html = `<h4>${first ? 'Estimation initiale' : 'Dernière estimation'} :</h4>`
                if (firstDeclaredCons && firstDeclaredCons.cons) {
                    html += `De <b>${moment(firstDeclaredCons.timePeriod.startDate).format('DD/MM/YYYY')}</b> à <b>${moment(firstDeclaredCons.timePeriod.endDate).format('DD/MM/YYYY')}</b>`
                    html += `<br><div>CAR déclarée par le client :</div>`
                    html += `<ul><li>${_.map(firstDeclaredCons.cons, (value, tempClass) => `<strong>${tempClass}</strong> : ${value} kWh/an`).join('</li><li>')}</li></ul>`
                } else {
                    html += `Pas d'estimation (basé sur l'historique de consommation)`
                }
                return html
            })
            .catch(ErrorCatcher)
        }

        $scope.validating = {}
    },
})
)
